import { API_CACHE_KEYS } from "api/cacheKeys";
import { BaseQueryOptions } from "api/types";
import { useCustomQuery } from "api/useCustomQuery";
import { FilterParams } from "components/dataGridFilter/FiltersData";
import { JANZU_URL } from "config/config";

export type GetImageQueriesFiltersByTypeParams = {
  detectorId?: string;
};

type UseGetImageQueriesFiltersByTypeParams = {
  params?: GetImageQueriesFiltersByTypeParams;
  options?: BaseQueryOptions<GetImageQueriesFiltersByTypeResponse>;
};

type GetImageQueriesFiltersByTypeResponse = {
  filters: FilterParams[];
};

function useGetImageQueriesFiltersByType({ params, options }: UseGetImageQueriesFiltersByTypeParams = {}) {
  const url = `${JANZU_URL}reef-api/image-queries/filters-by-type`;
  const searchParams = new URLSearchParams();

  if (params?.detectorId !== undefined) {
    searchParams.append("detector_id", params.detectorId);
  }

  return useCustomQuery<GetImageQueriesFiltersByTypeResponse>(
    API_CACHE_KEYS.imageQueries.filtersByType(params),
    `${url}?${searchParams.toString()}`,
    options
  );
}

type UseImageQueriesFiltersByTypeParams = {
  getOptions?: {
    params?: GetImageQueriesFiltersByTypeParams;
  };
};

export function useImageQueriesFiltersByType({ getOptions }: UseImageQueriesFiltersByTypeParams = {}) {
  const imageQueriesFiltersByType = useGetImageQueriesFiltersByType(getOptions);

  return {
    // Get operations
    imageQueriesFiltersByType: imageQueriesFiltersByType.data,
    isLoadingImageQueriesFiltersByType: imageQueriesFiltersByType.isLoading,
    imageQueriesFiltersByTypeError: imageQueriesFiltersByType.error,
  };
}
